import clsx from 'clsx';
import type { JSX } from 'react';
import { type ButtonProps as RACButtonProps, Button as RACButton } from 'react-aria-components';
import { IconCloseBold, IconCloseCircle } from '../../../icons/index.js';
import type { CommonProps, IconProps } from '../../types.js';

interface XButtonProps
  extends CommonProps, Pick<RACButtonProps, 'isDisabled' | 'onPress' | 'slot' | 'excludeFromTabOrder'> {
  'aria-label': string;
  /** @default 'medium' */
  size?: 'small' | 'medium';
  /** @default 'square' */
  variant?: 'circle' | 'square';
  /** @default 'standard' */
  iconType?: 'standard' | 'circled';
}

const ICON_MAP: Record<NonNullable<XButtonProps['iconType']>, (props: IconProps) => JSX.Element> = {
  standard: IconCloseBold,
  circled: IconCloseCircle,
};

/**
 * @internal
 */
export function XButton({
  size = 'medium',
  variant = 'square',
  iconType = 'standard',
  UNSAFE_className,
  UNSAFE_style,
  ...props
}: XButtonProps) {
  const Icon = ICON_MAP[iconType];

  return (
    <RACButton
      {...props}
      className={clsx('cim-x-button', UNSAFE_className)}
      style={UNSAFE_style}
      data-size={size}
      data-variant={variant}
    >
      <Icon />
    </RACButton>
  );
}
